import { DynamicFieldConfig } from '../interfaces';

// Interface para arquivo selecionado
export interface SelectedFile {
    name: string;
    size: number;
    type: string;
    lastModified: number;
}

/**
 * Valida e define arquivo para um campo
 */
export function validateAndSetFile(
    file: File, 
    field: DynamicFieldConfig, 
    selectedFiles: Map<string, SelectedFile>
): { isValid: boolean; error?: string } {
    
    // Validar tipo de arquivo
    if (field.accept && field.accept !== '*') {
        const acceptedTypes = field.accept.split(',').map(type => type.trim());
        const fileExtension = '.' + file.name.split('.').pop()?.toLowerCase();
        const fileType = file.type;
        
        const isAccepted = acceptedTypes.some(type => {
            if (type.startsWith('.')) {
                return fileExtension === type.toLowerCase();
            }
            return fileType === type || fileType.startsWith(type.replace('*', ''));
        });
        
        if (!isAccepted) {
            return {
                isValid: false,
                error: `Tipo de arquivo não suportado. Tipos aceitos: ${field.accept}`
            };
        }
    }

    // Validar tamanho do arquivo
    if (field.maxSize && file.size > field.maxSize) {
        const maxSizeMB = field.maxSize / (1024 * 1024);
        return {
            isValid: false,
            error: `Arquivo muito grande. Tamanho máximo: ${maxSizeMB}MB`
        };
    }

    // Arquivo válido
    selectedFiles.set(field.name, {
        name: file.name,
        size: file.size,
        type: file.type,
        lastModified: file.lastModified
    });

    return { isValid: true };
}

/**
 * Obtém arquivo selecionado para um campo
 */
export function getSelectedFile(fieldName: string, selectedFiles: Map<string, SelectedFile>): SelectedFile | undefined {
    return selectedFiles.get(fieldName);
}

/**
 * Remove arquivo de um campo
 */
export function removeFile(fieldName: string, selectedFiles: Map<string, SelectedFile>): void {
    selectedFiles.delete(fieldName);
}

/**
 * Formata tamanho do arquivo para exibição
 */
export function formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

/**
 * Dispara clique no input de arquivo
 */
export function triggerFileInput(fieldName: string): void {
    const fileInput = document.getElementById(`field-${fieldName}`) as HTMLInputElement;
    if (fileInput) {
        fileInput.click();
    }
}

/**
 * Manipula evento de drag over
 */
export function onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
}

/**
 * Manipula evento de drop
 */
export function onDrop(
    event: DragEvent, 
    field: DynamicFieldConfig, 
    selectedFiles: Map<string, SelectedFile>,
    onFileChange: (event: any, field: DynamicFieldConfig) => void
): void {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
        const file = files[0];
        const mockEvent = { target: { files: [file] } };
        onFileChange(mockEvent, field);
    }
} 